import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import { Card, CardContent, Heading, Separator } from 'telia-front-react';
import * as React from 'react';
import { Segment } from '../../stores/SegmentStore';
import OperatorSelection from './OperatorSelection';
import SelectedOperator from './SelectedOperator';
import RoamingStore from '../../stores/RoamingStore';

interface RoamingOperatorsProps {
  segment: Segment;
  roamingStore?: RoamingStore;
}

const RoamingOperators = (props: RoamingOperatorsProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const {
    roamingStore: { selectedCountry },
    segment
  } = props;

  if (!selectedCountry) {
    return null;
  }

  return (
    <>
      <Heading level={2} id="price-info">
        {translate('roaming.operators.heading')}
      </Heading>
      <Separator spacing="xsmall" color="invisible" />
      <Card padding="small" responsive={[{ breakPoint: 'md', props: { padding: 'xlarge' } }]}>
        <CardContent>
          {selectedCountry.isoCode !== 'RUS' && <OperatorSelection />}
          <SelectedOperator segment={segment} />
        </CardContent>
      </Card>
    </>
  );
};

export default inject('roamingStore')(observer(RoamingOperators));
